import React from 'react';
import { useIntl } from 'react-intl';
import ExpandableWrapper from '../ExpandableWrapper';
import MarkdownEditor from '../MarkdownEditor';

const Data = ({
  value, onChange, selected, expanded
}) => {
  const intl = useIntl();

  return (
    <ExpandableWrapper onChange={ onChange } selected={ selected } id="data" title={ intl.formatMessage({ id: 'manage.detail.tab.technicalDetails.data' }) } expanded={ expanded }>
      <MarkdownEditor value={ value } />
    </ExpandableWrapper>
  );
};

export default Data;
